import { render, staticRenderFns } from "./FirstResourceForm.vue?vue&type=template&id=3c67b53f"
import script from "./FirstResourceForm.vue?vue&type=script&lang=js"
export * from "./FirstResourceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports